import React from 'react';
import MetaTags from '../../components/seo/MetaTags';
import CookiePreferenceCenter from '../../components/cookies/CookiePreferenceCenter';

export default function CookiePolicy() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 pt-20">
      <MetaTags
        title="Cookie Policy | DiversiCoin Bitcoin BTM Network"
        description="Learn about how we use cookies and similar technologies on our website."
        url="https://www.DiversiCoin.cash/cookie-policy"
      />
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-gray-800 rounded-lg p-8">
          <h1 className="text-3xl font-bold text-white mb-6">Cookie Policy</h1>
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">Cookie Preferences</h2>
            <p className="text-gray-300 mb-4">
              Manage your cookie preferences below. Essential cookies cannot be disabled as they are 
              required for the website to function properly.
            </p>
            <CookiePreferenceCenter />
          </div>
          <div className="prose prose-invert">
            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Last Updated</h2>
              <p className="text-gray-300">This policy was last updated on February 28, 2024</p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">What Are Cookies</h2>
              <p className="text-gray-300">
                Cookies are small text files that are stored on your device when you visit our website. 
                They help us provide you with a better experience by remembering your preferences, 
                analyzing site usage, and assisting with our marketing efforts.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Types of Cookies We Use</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Essential Cookies</h3>
                  <p className="text-gray-300">
                    Required for the website to function properly. These cannot be disabled and include:
                  </p>
                  <ul className="list-disc pl-6 text-gray-300 mt-2">
                    <li>Session management</li>
                    <li>Security features</li>
                    <li>Basic functionality</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Analytics Cookies</h3>
                  <p className="text-gray-300">
                    Help us understand how visitors interact with our website:
                  </p>
                  <ul className="list-disc pl-6 text-gray-300 mt-2">
                    <li>Page views and navigation</li>
                    <li>Time spent on site</li>
                    <li>Feature usage statistics</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Marketing Cookies</h3>
                  <p className="text-gray-300">
                    Used to track visitors across websites to display relevant advertisements:
                  </p>
                  <ul className="list-disc pl-6 text-gray-300 mt-2">
                    <li>Advertising preferences</li>
                    <li>Campaign effectiveness</li>
                    <li>Visitor behavior</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Managing Cookies</h2>
              <p className="text-gray-300">
                You can control cookies through your browser settings. Note that blocking some types of 
                cookies may impact your experience on our site and the services we can offer.
              </p>
              <p className="text-gray-300 mt-4">
                Most web browsers allow some control of most cookies through the browser settings. To find 
                out more about cookies, including how to see what cookies have been set, 
                visit <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:text-purple-300">www.allaboutcookies.org</a>.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Data Retention</h2>
              <p className="text-gray-300">
                Different cookies have different retention periods:
              </p>
              <ul className="list-disc pl-6 text-gray-300 mt-2">
                <li>Session cookies: Deleted when you close your browser</li>
                <li>Persistent cookies: Up to 2 years for analytics</li>
                <li>Marketing cookies: Up to 180 days</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">International Data Transfers</h2>
              <p className="text-gray-300">
                Some of our third-party cookie providers may process your data outside your country. 
                We ensure these transfers comply with applicable data protection laws and maintain 
                appropriate safeguards.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Your Rights (GDPR & CCPA)</h2>
              <p className="text-gray-300">
                Under data protection laws, you have rights regarding your personal data:
              </p>
              <ul className="list-disc pl-6 text-gray-300 mt-2">
                <li>Right to be informed about how we use cookies</li>
                <li>Right to withdraw consent at any time</li>
                <li>Right to object to processing based on legitimate interests</li>
                <li>Right to erasure of personal data collected via cookies</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Updates to This Policy</h2>
              <p className="text-gray-300">
                We may update this Cookie Policy from time to time. Any changes will be posted on this page 
                with an updated revision date. Please check back periodically to stay informed about our use 
                of cookies.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
              <p className="text-gray-300">
                If you have any questions about our use of cookies, please contact us at{' '}
                <a href="mailto:support@diversicoin.cash" className="text-purple-400 hover:text-purple-300">
                  support@diversicoin.cash
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}